<template>
  <div class="has-text-centered success_holder">
    <svg
      class="checkmark"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
    >
      <circle
        class="checkmark__circle"
        cx="26"
        cy="26"
        r="25"
        fill="none"
      />
      <path
        class="checkmark__check"
        fill="none"
        d="M14.1 27.2l7.1 7.2 16.7-16.8"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'BookmarkSuccess',
  mounted() {
    setTimeout(function(){
      try{

        const bc = new BroadcastChannel("qm_shortcut");
        bc.postMessage("close_window");

        window.opener = window;
        var win = window.open("","_self");
        win.close();
        top.close();
      }
      catch(e){
        //
      }
    }, 2000);
  }
}
</script>

<style lang="scss" scoped>
  .success_holder {

  }

  $checkmark-bg-color: rgb(53, 63, 115);
  $curve: cubic-bezier(0.650, 0.000, 0.450, 1.000);

  .checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 50;
    stroke-miterlimit: 10;
    stroke: $checkmark-bg-color;
    fill: none;
    animation: stroke .6s $curve forwards;
  }

  .checkmark {
    width: 200px;
    height: 200px;
    border-radius: 50%;
    display: block;
    stroke-width: 6;
    stroke: #fff;
    stroke-miterlimit: 10;
    margin: 10% auto;
    box-shadow: inset 0px 0px 0px $checkmark-bg-color;
    animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
  }

  .checkmark__check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke .3s $curve .8s forwards;
  }

  @keyframes stroke {
    100% {
      stroke-dashoffset: 0;
    }
  }

  @keyframes scale {
    0%, 100% {
      transform: none;
    }
    50% {
      transform: scale3d(1.1, 1.1, 1);
    }
  }

  @keyframes fill {
    100% {
      box-shadow: inset 0px 0px 0px 30px $checkmark-bg-color;
    }
  }
</style>
